import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditLaker = () => {
    const [customerName, setCustomerName] = useState('');
    const [pcs, setPcs] = useState('');
    const [grossWeight, setGrossWeight] = useState('');
    const [description, setDescription] = useState('');
    const { id } = useParams();
    const navigate = useNavigate();

    // Fetch the laker details when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}lakers/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const laker = data.data;
                    setCustomerName(laker.customer_name);
                    setPcs(laker.pcs);
                    setGrossWeight(laker.gross_weight);
                    setDescription(laker.description);
                } else {
                    console.error('Error fetching laker:', data.message);
                }
            })
            .catch(error => console.error('Error:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const updatedLakerData = {
            staff_id: 1, // Assuming staff_id is static for now
            customer_name: customerName,
            pcs: pcs,
            gross_weight: grossWeight,
            description: description,
        };

        fetch(`${BASE_URL}lakers/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedLakerData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    // Redirect to Lakers List after successful update
                    navigate('/LakersList');
                } else {
                    console.error('Error updating laker:', data.message);
                }
            })
            .catch(error => console.error('Error:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Laker</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h4>Edit Laker Details</h4>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/LakersList')}>Back to List</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="customerName" className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            id="customerName"
                                            className="form-control"
                                            value={customerName}
                                            onChange={(e) => setCustomerName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="pcs" className="form-label">PCS</label>
                                        <input
                                            type="number"
                                            id="pcs"
                                            className="form-control"
                                            value={pcs}
                                            onChange={(e) => setPcs(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="grossWeight" className="form-label">Gross Weight</label>
                                        <input
                                            type="number"
                                            id="grossWeight"
                                            className="form-control"
                                            value={grossWeight}
                                            onChange={(e) => setGrossWeight(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        ></textarea>
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-success">Update Laker</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditLaker;
